/**
 * SUPPLIER_NAV — the supplier portal's navigation registry.
 */
import { PackageCheck } from "lucide-react";

import type { PortalNavItem } from "@/components/navigation/PortalSidebar";

export const SUPPLIER_NAV: PortalNavItem[] = [
  {
    key: "orders",
    path: "/supplier/board",
    label: "Orders",
    icon: PackageCheck,
    iconClass: "text-icon-products",
  },
];
